import React from "react";
import cert1 from "../assets/certificates/python-michigan.jpeg";
import cert2 from "../assets/certificates/Html&JS.jpeg";
import cert3 from "../assets/certificates/MDS.png";
import cert4 from "../assets/certificates/Python-IIT.jpg";
import cert5 from "../assets/certificates/DB & SQL for DS.jpeg";
import cert6 from "../assets/certificates/Frontend meta.jpeg";
import cert7 from "../assets/certificates/hackerrank-sql.png";
import cert8 from "../assets/certificates/CS50 cert.jpg";

// strongest / most recognised first
const certificates = [
  { title: "Introduction to Databases with SQL (CS50)", issuer: "Harvard University", image: cert8, link: "https://cs50.harvard.edu/certificates/84c94b7b-5c11-41d1-96a8-482b065651f1" },
  { title: "Databases & SQL for Data Science", issuer: "IBM", image: cert5, link: "https://coursera.org/verify/DQZRPSLPR475" },
  { title: "Python IIT Certification", issuer: "IIT Madras & Guvi", image: cert4, link: "https://skillsacademy.iitm.ac.in/iitprogram/pages/certificate/524oaVQ157615xNl62.pdf" },
  { title: "Introduction to Front-End Development", issuer: "Meta", image: cert6, link: "https://coursera.org/verify/BPJ49T94EQGP" },
  { title: "Python for Everybody", issuer: "University of Michigan", image: cert1, link: "https://coursera.org/verify/ZTPCWF5FXU24" },
  { title: "Programming with JS, HTML & CSS", issuer: "Duke University", image: cert2, link: "https://coursera.org/verify/GVESKKD9FYAD" },
  { title: "Master Data Science Program", issuer: "Guvi", image: cert3, link: "https://www.guvi.in/share-certificate/7Q7tA6fc2i042s613y" },
  { title: "SQL (Basic) Certification", issuer: "HackerRank", image: cert7, link: "https://www.hackerrank.com/certificates/7f9f5f7e5176" },
];

const Achievements = () => {
  return (
    <div className="sec" id="achievements">
      <div className="wrap">
        <div className="sec-h"><span className="hash">##</span> certifications</div>
        <div className="cert-list">
          {certificates.map((c, i) => (
            <a
              className="cert-row"
              key={i}
              href={c.link}
              target="_blank"
              rel="noopener noreferrer"
              data-aos="fade-up"
              data-aos-delay={i * 40}
            >
              <img src={c.image} alt={c.title} className="cert-thumb" loading="lazy" />
              <div className="cert-meta">
                <div className="cert-title">{c.title}</div>
                <div className="cert-issuer">{c.issuer}</div>
              </div>
              <span className="cert-verify">verify →</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Achievements;